import React from "react";
import { observer } from "mobx-react";
import { AiSearchToolCallViewStore } from "../../store";
import { AiSearchToolCallViewForm } from "./AiSearchToolCallViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type AiSearchToolCallViewProps = {
  aiSearchToolCallViewStore: AiSearchToolCallViewStore;
};

export const AiSearchToolCallView: React.FC<AiSearchToolCallViewProps> =
  observer(({ aiSearchToolCallViewStore }) => {
    return (
      <div>
        <AiSearchToolCallViewForm
          sequence={aiSearchToolCallViewStore.sequenceValue}
          toolName={aiSearchToolCallViewStore.toolNameValue}
          pattern={aiSearchToolCallViewStore.patternValue}
          navigationPath={aiSearchToolCallViewStore.navigationPathValue}
          toolArguments={aiSearchToolCallViewStore.toolArgumentsValue}
          result={aiSearchToolCallViewStore.resultValue}
          durationMs={aiSearchToolCallViewStore.durationMsValue}
          success={aiSearchToolCallViewStore.successValue}
          errorMessage={aiSearchToolCallViewStore.errorMessageValue}
          onPrint={(handlePrint: () => void) =>
            aiSearchToolCallViewStore.printAiSearchToolCall(handlePrint)
          }
          onCancel={() => aiSearchToolCallViewStore.cancelAiSearchToolCall()}
          onEdit={
            aiSearchToolCallViewStore.isEditEnabled
              ? () => aiSearchToolCallViewStore.editAiSearchToolCall()
              : undefined
          }
        />
        <ErrorDialog
          open={aiSearchToolCallViewStore.errorDialogOpened}
          title={aiSearchToolCallViewStore.errorTitle}
          description={aiSearchToolCallViewStore.errorDescription}
          onClose={() => aiSearchToolCallViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
